import React, { FC, useEffect, useState } from 'react';
import { ToggleButton, Flex, View } from '@adobe/react-spectrum';
import Camera from '@spectrum-icons/workflow/Camera';
import { useScreenshotState } from '~/Context/contextScreenshot';
import { _system } from '~/Services/Studio/studioScene';

export const CanvasScreenshot: FC = () => {
    const [show, setShow] = useState<boolean>(false);
    const { screenshotCallback, screenshot } = useScreenshotState();

    useEffect(() => {
        if (screenshotCallback !== null) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [screenshotCallback]);

    if (show) {
        return (
            <Flex
                flex
                alignItems="center"
                direction="column"
                gap="size-100"
                position="absolute"
                zIndex={2}
                bottom="20px"
                left="calc(50% - size-600 / 2)"
            >
                <View backgroundColor="gray-100" borderRadius="medium">
                    <ToggleButton onPress={screenshot} height="size-700" width="size-700">
                        <Camera height="size-400" width="size-400" />
                    </ToggleButton>
                </View>
            </Flex>
        );
    }
    return (<></>);
};
